import { render } from "./AddShg.vue?vue&type=template&id=0e16dc3b&scoped=true"
import script from "./AddShg.vue?vue&type=script&lang=js"
export * from "./AddShg.vue?vue&type=script&lang=js"

import "./AddShg.vue?vue&type=style&index=0&id=0e16dc3b&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3194113096/src/coop-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e16dc3b"]])

export default __exports__